/**
 * 
 */
export default [
    {
        text: 'RUT',
        sortable: false,
        value: 'rut',
    },
    {
        text: 'NOMBRES',
        sortable: false,
        value: 'names',
    },
    {
        text: 'PRIMER APELLIDO',
        sortable: false,
        value: 'last_name1',
    },
    {
        text: 'SEGUNDO APELLIDO',
        sortable: false,
        value: 'last_name2',
    },
    {
        text: 'EMAIL',
        sortable: false,
        value: 'email',
    },
    {
        text: 'CARGAS FAMILIARES',
        sortable: false,
        fieldType: 'computed',
        computed: ({ hr_family_burdens }) => hr_family_burdens.length,
        value: 'hr_family_burdens',
    },
    {
        text: 'PREVISIÓN',
        sortable: false,
        fieldType: 'computed',
        computed: ({ hr_prevision }) => hr_prevision.name,
        value: 'hr_prevision',
    },
    {
        text: 'Contrato',
        fieldType: 'computed',
        computed: ({ active_contract})=> {
            if(active_contract){
                return 'Activo'
            }
            else{
                return 'No activo'
            }
        }
    }
]
